import type { GitHubAppConnectionSummary } from "@octopusdeploy/octopus-server-client";
import React from "react";
import useRequiredContext from "~/hooks/useRequiredContext";
type ProcessGitHubConnectionsContextValue = GitHubAppConnectionSummary[];
type ProcessGitHubConnectionsRefreshContextValue = () => Promise<void>;
const ProcessGitHubConnectionsContext = React.createContext<ProcessGitHubConnectionsContextValue>([]);
const RefreshProcessGitHubConnectionsContext = React.createContext<ProcessGitHubConnectionsRefreshContextValue | undefined>(undefined);
export function useGitHubConnectionsFromContext(): ProcessGitHubConnectionsContextValue {
    return useRequiredContext(ProcessGitHubConnectionsContext, "ProcessGitHubConnectionsContext");
}
export function useRefreshGitHubConnectionsFromContext(): ProcessGitHubConnectionsRefreshContextValue {
    return useRequiredContext(RefreshProcessGitHubConnectionsContext, "RefreshProcessGitHubConnectionsContext");
}
type ProcessGitHubConnectionsContextProviderProps = {
    gitHubConnections: GitHubAppConnectionSummary[];
    refreshGitHubConnections: () => Promise<void>;
};
export function ProcessGitHubConnectionsContextProvider(props: React.PropsWithChildren<ProcessGitHubConnectionsContextProviderProps>) {
    return (<ProcessGitHubConnectionsContext.Provider value={props.gitHubConnections}>
            <RefreshProcessGitHubConnectionsContext.Provider value={props.refreshGitHubConnections}>{props.children}</RefreshProcessGitHubConnectionsContext.Provider>
        </ProcessGitHubConnectionsContext.Provider>);
}
